import { toast, Tooltip, TooltipContent, TooltipTrigger } from "@veritrellis/ui";
import { Copy } from "lucide-react";

type CopyButtonProps = {
  value: string;
  label?: string;
};

export const CopyButton = ({ value, label = "Copy" }: CopyButtonProps) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast.show({ title: "Copied", message: "Copied to clipboard.", color: "green" });
    } catch {
      toast.show({ title: "Failed", message: "Clipboard unavailable.", color: "red" });
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => void copy()}
          className="admin-icon-button"
          aria-label={label}
        >
          <Copy style={{ width: 14, height: 14 }} />
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
